import { useQuery } from "@tanstack/react-query";
import { authenticatedGet } from "./authenticatedFetch";

const BASE = "/api/v1";

export const getCurrentUser = async () => {
  return authenticatedGet(`${BASE}/users/me`);
};

export const useCurrentUser = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: getCurrentUser,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    select: (data) => data?.user,
  });
};
